import { render, staticRenderFns } from "./ExtraSubjectNewDialog.vue?vue&type=template&id=411fa2b7"
import script from "./ExtraSubjectNewDialog.vue?vue&type=script&lang=js"
export * from "./ExtraSubjectNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports